import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl, } from 'react-bootstrap';
import accounting from 'accounting';
import { getCurrencySymbol } from 'components/modules/master/formatters';
export default class AccessorialRatesFlatFeeEditor extends React.Component {
    handleFlatFeeChange() {
        return (e) => {
            const rate = Number(e.target.value);
            this.props.onChange('rate', rate);
            const description = accounting.formatMoney(rate, getCurrencySymbol(DEFAULT_CURRENCY));
            this.props.onChange('description', description);
        };
    }
    validateValue(rate) {
        if (rate > 0) {
            return '';
        }
        return 'error';
    }
    render() {
        const accessorialRate = this.props.accessorialRate || {};
        return (React.createElement(Grid, { fluid: true },
            React.createElement(Row, { className: "show-grid" },
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, `${accessorialRate.name} (${getCurrencySymbol(DEFAULT_CURRENCY)})`),
                        React.createElement(FormControl, { type: "number", defaultValue: accessorialRate.rate, onChange: this.handleFlatFeeChange(), bsStyle: this.validateValue(accessorialRate.rate) }))))));
    }
}
AccessorialRatesFlatFeeEditor.propTypes = {
    accessorialRate: PropTypes.object,
    onChange: PropTypes.func,
};
